import { GlobalStyles } from '@mui/material';
import { TOAST_ANIMATIONS, TOAST_STEPS } from './const';

export const AnimationStyles = () => {
  return (
    <GlobalStyles
      styles={{
        [`@keyframes toast-${TOAST_STEPS.INIT}-${TOAST_ANIMATIONS.FADE}`]: {
          from: { opacity: 0 },
          to: { opacity: 1 },
        },

        [`@keyframes toast-close-${TOAST_ANIMATIONS.FADE}`]: {
          from: { opacity: 1 },
          to: { opacity: 0 },
        },

        [`@keyframes toast-${TOAST_STEPS.INIT}-${TOAST_ANIMATIONS.SLIDE_UP}`]: {
          from: {
            opacity: 0,
            transform: 'translateY(-40px)',
          },
          to: {
            opacity: 1,
            transform: 'translateY(0px)',
          },
        },

        [`@keyframes toast-${TOAST_STEPS.CLOSE}-${TOAST_ANIMATIONS.SLIDE_UP}`]: {
          to: {
            opacity: 0,
            transform: 'translateY(-40px)',
          },
          from: {
            opacity: 1,
            transform: 'translateY(0px)',
          },
        },

        [`@keyframes toast-${TOAST_STEPS.INIT}-${TOAST_ANIMATIONS.SLIDE_DOWN}`]: {
          from: {
            opacity: 0,
            transform: 'translateY(40px)',
          },
          to: {
            opacity: 1,
            transform: 'translateY(0px)',
          },
        },

        [`@keyframes toast-${TOAST_STEPS.CLOSE}-${TOAST_ANIMATIONS.SLIDE_DOWN}`]: {
          to: {
            opacity: 0,
            transform: 'translateY(40px)',
          },
          from: {
            opacity: 1,
            transform: 'translateY(0px)',
          },
        },

        [`@keyframes toast-${TOAST_STEPS.INIT}-${TOAST_ANIMATIONS.SLIDE_LEFT}`]: {
          from: {
            opacity: 0,
            transform: 'translateX(-80px)',
          },
          to: {
            opacity: 1,
            transform: 'translateX(0px)',
          },
        },

        [`@keyframes toast-${TOAST_STEPS.CLOSE}-${TOAST_ANIMATIONS.SLIDE_LEFT}`]: {
          to: {
            opacity: 0,
            transform: 'translateX(-80px)',
          },
          from: {
            opacity: 1,
            transform: 'translateX(0px)',
          },
        },

        [`@keyframes toast-${TOAST_STEPS.INIT}-${TOAST_ANIMATIONS.SLIDE_RIGHT}`]: {
          from: {
            opacity: 0,
            transform: 'translateX(80px)',
          },
          to: {
            opacity: 1,
            transform: 'translateX(0px)',
          },
        },

        [`@keyframes toast-${TOAST_STEPS.CLOSE}-${TOAST_ANIMATIONS.SLIDE_RIGHT}`]: {
          to: {
            opacity: 0,
            transform: 'translateX(80px)',
          },
          from: {
            opacity: 1,
            transform: 'translateX(0px)',
          },
        },
      }}
    />
  );
};
